module.exports = __webpack_public_path__ + "img/target.5826e1da.svg";